import { Typography } from '@sunwebgroup/uds-ui/typography'
import { Bar } from './Bar'
import styles from './ScoreBar.module.css'

interface ScoreBarProps {
  score?: number
  label: string
}

export function ScoreBar({ score, label }: ScoreBarProps) {
  return (
    <>
      <div className={styles.typographyWrapper}>
        <Typography variant="body-m-regular-tight">{label}</Typography>
      </div>
      <Bar score={score || 0} label={label} />
    </>
  )
}
